module.exports = __webpack_public_path__ + "img/4.df978b00.png";